






import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

@Component
export default class EnrollmentStatus extends Vue {
  @Prop()
  type: string;

  @Prop()
  statusText: string;
}
